import React from 'react';
import { Helmet } from 'react-helmet-async';
import { shopProducts, shopCategories } from '../data/shopData';
import ProductCard from './ProductCard';
import SocialLearning from './SocialLearning';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen, FiGlobe, FiUsers, FiArrowDown } from 'react-icons/fi';

const SalasPage = () => {
  // Priority: Show Group Rooms first
  const groupRooms = shopProducts.filter(p => p.category === 'group');
  const restOfCatalog = shopProducts.filter(p => p.category !== 'group');

  return (
    <div className="min-h-screen bg-black pt-32 pb-20">
      <Helmet>
        <title>Salas de Conversación 24/7 | Online Classes English</title>
        <meta name="description" content="Practica tu inglés en tiempo real con estudiantes de todo el mundo en nuestras salas 24/7." />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-6xl md:text-9xl font-black text-white mb-6 uppercase italic tracking-tighter leading-none">
            Salas de <span className="text-blue-500">Práctica</span>
          </h1>
          <p className="text-2xl text-gray-400 max-w-3xl mx-auto font-medium">
            No esperes a tu próxima clase. Entra a una sala ahora mismo y empieza a hablar con la comunidad global.
          </p>
        </div>

        <SocialLearning />

        {/* Primary Group Rooms */}
        <div className="mt-32">
          <h2 className="text-4xl font-black text-white uppercase italic mb-12 flex items-center gap-6">
            <SafeIcon icon={FiUsers} className="text-blue-500" /> Opciones de Acceso Grupal
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {groupRooms.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>

        {/* Full Catalog Transition */}
        <div className="mt-40 text-center mb-20">
            <div className="inline-block bg-zinc-900 border border-zinc-800 px-8 py-3 rounded-full text-xs font-black uppercase tracking-[0.3em] text-gray-500 mb-8">
                Campus Completo 2026
            </div>
            <h2 className="text-5xl font-black text-white uppercase italic">¿Necesitas <span className="text-yellow-500">Más Poder?</span></h2>
            <p className="text-gray-400 mt-4">Explora el resto de nuestro catálogo para complementar tu práctica.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {restOfCatalog.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default SalasPage;